import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  padding: 24px;
  display: grid;
  gap: 24px;
  grid-template-columns: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eaeef1;
`;

export const WrapperDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #161d1f;
`;

export const WrapperCards = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, calc((100% - 24px) / 2));

  @media (max-width: 640px) {
    grid-template-columns: 100%;
  }
`;

export const WrapperCard = styled(Link)`
  width: 100%;
  padding: 16px;
  display: grid;
  grid-template-columns: calc(100% - 24px) 24px;
  border-radius: 8px;
  background-color: #ecf4f9;
  outline: none;

  &:hover {
    background-color: #d5e5f0;
  }

  &:focus-visible,
  &:active {
    background-color: #a8cbe2;
  }

  > div:first-child {
    > cc-icon {
      color: #5b36f2;
      margin-bottom: 24px;
    }

    > img {
      height: 32px;
      width: 32px;
      margin-bottom: 24px;
    }

    > h3 {
      font-weight: 700;
      line-height: 32px;
      margin-bottom: 4px;
      font-size: 24px;
      color: #161d1f;
    }

    > span {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
    }
  }

  > div:last-child {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > cc-icon {
      color: #5b36f2;
    }
  }

  &.disabled {
    background-color: #ecf4f9;
    pointer-events: none;

    div,
    span,
    h3 {
      color: #8090bb !important;
    }

    cc-icon {
      opacity: 0;
    }
  }
`;
